import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { useTranslator } from '@bluebeam/react-i18n';
import { GeneralIcons } from '@bluebeam/react-skyline-art';
import { IconButton } from '@bluebeam/react-skyline-icon-button';
import { cloneElement, useContext, useEffect, useRef } from 'react';
import BannerContext from './BannerContext';
/** A banner is a type of **molecule** that represents an alert. */
const PlatformBanner = ({ children, className, description, icon, onDismiss, ariaClose, ...rest }) => {
    const { setHeight } = useContext(BannerContext);
    const bannerRef = useRef(null);
    const { translate } = useTranslator(['local']);
    const dataAttributes = useDataAttributes(rest);
    useEffect(() => {
        if (bannerRef.current) {
            setHeight(bannerRef.current.getBoundingClientRect().height);
        }
        return () => {
            setHeight(0);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bannerRef]);
    return (_jsxs("div", { "aria-describedby": "banner-description", className: buildClassName('bg-gray skyline-text-body-1 fixed left-0 right-0 flex h-10 w-full items-center justify-between rounded-lg text-black ', className), ref: bannerRef, role: "banner", tabIndex: -1, ...dataAttributes, children: [_jsxs("header", { className: "flex w-full items-center justify-center", children: [_jsx("div", { children: icon
                            ? cloneElement(icon, {
                                className: 'mr-4 align-middle tablet:mr-0 text-alerts-warning-orange',
                                'aria-label': description,
                            })
                            : null }), _jsx("p", { id: "banner-description", className: buildClassName('my-0 mr-0 line-clamp-2 basis-auto leading-5', {
                            'mr-12': Boolean(children),
                        }), children: description }), children] }), _jsx(IconButton, { "aria-label": ariaClose === undefined ? translate('local:close') : ariaClose, variant: "text", onClick: onDismiss, className: "hover:bg-color-none mr-4", children: _jsx(GeneralIcons.CloseIcon, { size: "24px" }) })] }));
};
export default PlatformBanner;
//# sourceMappingURL=PlatformBanner.js.map